import type { PublicVenue as GQLCheckoutVenue } from '../generated/checkout.graphql';
import * as CheckoutVenueLogo from './CheckoutVenueLogo';
import type { Address } from './Address';
import { take } from '../util/takePayload';

export type CheckoutVenue = {
  id: number;
  name: string;
  logoUrl: string;
  timeZone: string;
  locale?: string;
  currency?: string;
  logo?: CheckoutVenueLogo.CheckoutVenueLogo;
} & Address;

export const fromGql = (gqlVenue: GQLCheckoutVenue): CheckoutVenue => {
  return {
    ...(take<CheckoutVenue>(
      gqlVenue,
      'id',
      'name',
      'logoUrl',
      'locale',
      'currency',
      'state',
      'city',
      'street1',
      'street2',
      'timeZone',
    )),
    logo: gqlVenue.logo ? CheckoutVenueLogo.fromGql(gqlVenue.logo) : undefined,
  };
};
